import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tabsContainer'];

  connect() {
    requestAnimationFrame(() => {
      this.scrollToActiveTab();
    });
  }

  scrollToActiveTab() {
    if (this.tabsContainerTarget.scrollWidth <= this.tabsContainerTarget.clientWidth) {
      return;
    }

    const activeTab = this.tabsContainerTarget.querySelector('[data-active="true"]');

    if (activeTab) {
      activeTab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }
}
